import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
// Import about image
import aboutImage from "../assets/images/aboutUs.jpg"; // Adjust the path as needed

// Styled components
const StyledAboutSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  backgroundColor: theme.palette.background.default,
}));

const StyledAboutContainer = styled(Container)(({ theme }) => ({
  maxWidth: "lg",
}));

const StyledAboutGrid = styled(Grid)(({ theme }) => ({
  alignItems: "center",
}));

const StyledAboutContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const StyledAboutTitle = styled(Typography)<{ component?: React.ElementType }>(
  ({ theme }) => ({
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
  })
);

const StyledAboutText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  lineHeight: 1.8,
}));

const StyledAboutTextItalic = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  lineHeight: 1.8,
  fontStyle: "italic",
}));

const StyledAboutTextBold = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  lineHeight: 1.8,
  fontWeight: "bold",
}));

const StyledAboutImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "400px",
  objectFit: "cover",
  borderRadius: theme.spacing(1),
}));

export const AboutSection: React.FC = () => {
  return (
    <StyledAboutSection id="about">
      <StyledAboutContainer>
        <StyledAboutGrid container spacing={6}>
          <Grid item xs={12} md={6}>
            <StyledAboutContent>
              <StyledAboutTitle variant="h4">Over Ons</StyledAboutTitle>
              <StyledAboutText variant="body1">
                Welkom bij Pippaya – geboren uit liefde, opgedragen aan mijn twee
                onvergetelijke meisjes die mijn hart jarenlang vulden
                met kwispels, modderpoten en pure vreugde. Na hun afscheid bleef
                het stil… maar ook een droom wakker: een plek creëren waar
                andere honden zich net zo thuis mogen voelen als zij bij mij
                deden.
              </StyledAboutText>

              <StyledAboutTextItalic variant="body1">
                Dus nee, dit is geen hondenhotel.
              </StyledAboutTextItalic>

              <StyledAboutText variant="body1">
                Dit is een huis met een open deur, een zachte bank en altijd wel
                iemand in de buurt met een vrije hand voor een aai.
              </StyledAboutText>

              <StyledAboutText variant="body1">
                Hier draait alles om rust, aandacht en gezelligheid – zonder
                drukte, zonder hokken. Ik vang bewust maximaal 2 grote honden en
                1 kleintje op (ja, die telt als een halve). Zo krijgt elke hond
                de ruimte én liefde die hij verdient.
              </StyledAboutText>

              <StyledAboutText variant="body1">
                Binnen wordt er geluierd, geknuffeld en stiekem op kussens
                geslapen. Buiten? Daar vind je een tuin vol avontuur – ideaal
                voor speurneuzen, sprintjes en de onvermijdelijke
                modderbadliefhebbers (die hier met open armen worden ontvangen –
                en handdoeken).
              </StyledAboutText>

              <StyledAboutTextBold variant="body1">
                Voor honden die liever bij mij slapen dan in een pension. Geen
                kennel. Geen stress. Wel een zachte bank en een liefdevolle
                blik.
              </StyledAboutTextBold>
            </StyledAboutContent>
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledAboutImage src={aboutImage} alt="Huisdieropvang sfeer" />
          </Grid>
        </StyledAboutGrid>
      </StyledAboutContainer>
    </StyledAboutSection>
  );
};
